import Edit from "./Composer";

Edit.install = function(Vue) {
  Vue.component(Edit.name, Edit);
};

export default Edit;
